module.exports = __webpack_public_path__ + "static/media/bg-simple-1440.0314d2fc.jpg";